// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1ucc5","buttons":"Footer_buttons__1Zb8y"};